/**
 * @generated SignedSource<<54c4f2564636e426b834bca845d78674>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ecommerceTrackingProductData_item$data = {
  readonly address: {
    readonly englishCountryName: string | null;
  } | null;
  readonly browseUrl: string | null;
  readonly categoryCode: string | null;
  readonly contemporaryTrackingString: string;
  readonly displayPriceTracking: ReadonlyArray<{
    readonly amountType: string | null;
    readonly convertedAmountList: ReadonlyArray<{
      readonly amount: number | null;
      readonly currency: Currency | null;
    } | null> | null;
    readonly textType: string | null;
  } | null> | null;
  readonly isNewListing: boolean | null;
  readonly personalizationType: string | null;
  readonly seller: {
    readonly serviceId: string | null;
  } | null;
  readonly serviceId: string | null;
  readonly title: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"shippingCostHelpers_item">;
  readonly " $fragmentType": "ecommerceTrackingProductData_item";
};
export type ecommerceTrackingProductData_item$key = {
  readonly " $data"?: ecommerceTrackingProductData_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"ecommerceTrackingProductData_item">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "ecommerceTrackingProductData_item"
};

(node as any).hash = "344aca61eb12455aa0b961bb78e8c5b5";

export default node;
